import { render, staticRenderFns } from "./nutriScore.vue?vue&type=template&id=6399e56c&scoped=true"
import script from "./nutriScore.vue?vue&type=script&lang=js"
export * from "./nutriScore.vue?vue&type=script&lang=js"
import style0 from "./nutriScore.vue?vue&type=style&index=0&id=6399e56c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6399e56c",
  null
  
)

export default component.exports